export const TOPIC0_CREATE_BORROWER_EVENT = '0x1ff0a9a76572c6e0f2f781872c1e45b4bab3a0d90df274ebf884b4c11e3068f4';
export const TOPIC0_ENROLL_COURIER_EVENT = '0x9038af148c4bb36b89ff46ec17f02b27c5ab1e0ca181c0f0981b986a78b002d5';
export const TOPIC0_CREATE_MARKET_EVENT = '0x3f53d2c2743b2b162c0aa5d678be4058d3ae2043700424be52c04105df3e2411';
export const TOPIC0_IV = '0x53b9cc863ef106711e52ad6543fa1d2931ce5f0fbd6350d0fd7da64b471d43c1';
